<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-26 20:06:36
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-12 15:46:07
-->
<template>
	<div class="mt-12 yx-form-wrap">
		<Search @onSearch="onSubmit" @onReset="onClear">
			<el-form :inline="true" :model="formData" label-width="96px">
				<el-form-item label="商品名称">
					<el-input v-model="formData['product_name']" placeholder="请输入商品名称"></el-input>
				</el-form-item>
				<el-form-item label="商品ID">
					<el-input v-model="formData['third_product_id']" placeholder="请输入商品ID"></el-input>
				</el-form-item>
				<el-form-item label="店铺名称">
					<shop-name-select
						ref="shopNameSelect"
						passive
						:key="platformId"
						:platformId="platformId"
						v-model="formData.outer_shop_id"
					></shop-name-select>
				</el-form-item>
				<el-form-item label="推广状态">
					<el-select v-model="formData['other_status']" clearable placeholder="请选择推广状态">
						<el-option :label="item.label" :value="item.value" v-for="(item, index) in goodsPromoteStatusArr" :key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="商品类目">
					<yx-category-select v-model="formData['cate_id']" :platformId="platformId" isGoodsCat></yx-category-select>
				</el-form-item>
				<el-form-item label="佣金率">
					<div class="scope-input">
						<el-input v-model="formData['commission_rate_start']" placeholder="最小值" class="input_width"></el-input>
						<span class="flag">至</span>
						<el-input v-model="formData['commission_rate_end']" placeholder="最大值" class="input_width"></el-input>
					</div>
				</el-form-item>
				<el-form-item label="普通佣金率" v-if="$isPlatOr(platformId, ['Dy', 'Sp'])">
					<div class="scope-input">
						<el-input v-model="formData['normal_commission_rate_start']" placeholder="最小值" class="input_width"></el-input>
						<span class="flag">至</span>
						<el-input v-model="formData['normal_commission_rate_end']" placeholder="最大值" class="input_width"></el-input>
					</div>
				</el-form-item>
				<el-form-item label="佣金对比" v-if="$isPlatOr(platformId, ['Dy', 'Sp'])">
					<el-select v-model="formData['commission_rate_compare_value']" clearable placeholder="全部">
						<el-option :label="item.label" :value="item.value" v-for="(item, index) in commissionRateList" :key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="佣金模式" v-if="$isPlatOr(platformId, ['Dy','All'])">
					<el-select v-model="formData['commissionMode']" clearable placeholder="全部">
						<el-option label="全部" value="all"></el-option>
						<el-option label="双佣商品" value="double"></el-option>
						<el-option label="非双佣商品" value="single"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="授权团长">
					<commander-select :platformId="platformId" v-model="formData['authority_id']"></commander-select>
				</el-form-item>
				<!--先掩藏-->
				<el-form-item label="直播价" v-if="false">
					<div class="scope-input">
						<el-input v-model="formData['live_price_start']" placeholder="最小值" class="input_width"></el-input>
						<span class="flag">至</span>
						<el-input v-model="formData['live_price_end']" placeholder="最大值" class="input_width"></el-input>
					</div>
				</el-form-item>
				<el-form-item label="现售价">
					<div class="scope-input">
						<el-input v-model="formData['sale_price_start']" placeholder="最小值" class="input_width"></el-input>
						<span class="flag">至</span>
						<el-input v-model="formData['sale_price_end']" placeholder="最大值" class="input_width"></el-input>
					</div>
				</el-form-item>
				<el-form-item label="服务费率" v-if="$auth.hasPermi('system:goods-ServiceRate')">
					<div class="scope-input">
						<el-input v-model="formData['service_rate_start']" placeholder="最小值" class="input_width"></el-input>
						<span class="flag">至</span>
						<el-input v-model="formData['service_rate_end']" placeholder="最大值" class="input_width"></el-input>
					</div>
				</el-form-item>
				<el-form-item label="活动名称" v-if="$isPlatOr(platformId, ['Dy', 'Ks'])">
					<el-input v-model="formData['activity_name']" placeholder="请输入活动名称"></el-input>
				</el-form-item>
				<el-form-item label="活动ID" v-if="$isPlatOr(platformId, ['Dy', 'Ks'])">
					<el-input v-model="formData['outer_activity_id']" placeholder="请输入活动ID"></el-input>
				</el-form-item>
				<el-form-item label="报名状态" v-if="$isPlatOr(platformId, ['Dy', 'Ks'])">
					<el-select v-model="formData['audit_status']" clearable placeholder="请选择">
						<el-option :label="item.label" :value="item.value" v-for="(item, index) in auditStatusArr" :key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="zsName" prop="bd_user_id">
					<zs-partner-select v-model="formData.bd_user_ids" :collapseTags="true" :multiple="true"></zs-partner-select>
				</el-form-item>
				<el-form-item label="商品类型" prop="product_type" v-if="$isPlatOr(platformId, ['Dy', 'Ks'])">
					<el-select v-model="formData.product_type" clearable placeholder="请选择">
						<el-option :label="item.label" :value="item.value" v-for="(item, index) in filterGoodsTypeList" :key="index"></el-option>
					</el-select>
				</el-form-item>
				<template v-if="$isKs(platformId)">
					<!-- <el-form-item label="活动ID">
						<el-input v-model="formData.outer_activity_id" placeholder="请输入活动ID"></el-input>
					</el-form-item> -->
					<el-form-item label="活动类型">
						<el-select v-model="formData.activity_type" clearable placeholder="请选择活动类型">
							<el-option :label="item.label" :value="item.value" v-for="(item, index) in activityTypeList" :key="index"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="专属达人快手号/id" label-width="130px">
						<el-input v-model="formData.anchor_search" placeholder="请输入对应id"></el-input>
					</el-form-item>
					<el-form-item label="专属达人昵称">
						<el-input v-model="formData.anchor_name" placeholder="请输入达人昵称"></el-input>
					</el-form-item>
					<el-form-item label="到期时间：" prop="start_time">
						<el-date-picker
							v-model="freeOrderTime"
							type="daterange"
							@change="changeTimed"
							value-format="yyyy-MM-dd"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
						></el-date-picker>
					</el-form-item>
					<el-form-item label="推广者信息：" prop="contact_user_type">
						<el-select v-model="formData.contact_user_type" clearable placeholder="请选择">
							<el-option :label="item.label" :value="item.value" v-for="(item, index) in contactUserTypeArr" :key="index"></el-option>
						</el-select>
					</el-form-item>
				</template>
				<el-form-item label="店铺认领状态" v-if="followUpState && $isPlatOr(['Dy', 'Ks'])">
					<el-select v-model="formData['cooperateShopType']" clearable placeholder="请选择">
						<el-option :label="item.label" :value="item.value" v-for="(item, index) in dytoShopClaimedStateList" :key="index"></el-option>
					</el-select>
				</el-form-item>
				<template v-if="$isSp(platformId)">
					<el-form-item label="商品类型">
						<el-select v-model="formData.product_type" clearable placeholder="请选择">
							<el-option :label="item.label" :value="item.value" v-for="(item, index) in goodsTypeSelect" :key="index"></el-option>
						</el-select>
					</el-form-item>
				</template>
			</el-form>
			<defaultFilterTag
				@applicationSetting="applicationSetting"
				:dynamicsList="dynamicsList"
				:listType="listType"
				:platformId="platformId"
				slot="operate"
			/>
		</Search>
	</div>
</template>

<script>
import throttle from 'lodash/throttle';
import ZsPartnerSelect from '@/components/zsPartnerSelect';
import YxCategorySelect from '@/components/yxCategorySelect';
import { activityTypeList } from '@/utils/dataMap';
import { zsRoleType } from '@/utils/dataMap';
import { ksMyActivityUpStateList, dytoBeClaimedStateList, dytoShopClaimedStateList, goodsTypeList } from '@/utils/newDataMap/shopManage';
import { goodsPromoteStatusArr, commissionRateList } from '@/utils/newDataMap/shopManage';
import { format, addDays } from 'date-fns';
import { isEqual } from 'lodash';
import commanderSelect from '@/components/commanderSelect/index.vue';

import defaultFilterTag from '@/components/business/defaultFilter';
import { pageConfig } from '@/utils/dataMap';
import { configList } from './searchConfig';
import shopNameSelect from '@/components/shopNameSelect/shopNameSelect.vue';
export default {
	name: 'search',
	components: {
		ZsPartnerSelect,
		YxCategorySelect,
		commanderSelect,
		defaultFilterTag,
		shopNameSelect,
	},
	props: {
		platformId: {
			type: [String, Number],
			default: '',
		},
		followUpState: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			activityTypeList,
			formData: {
				audit_status: '',
				authority_id: '',
				outer_shop_id: '',
				outer_activity_id: '',
			},
			freeOrderTime: '',
			goodsPromoteStatusArr,
			commissionRateList,
			contactUserTypeArr: [
				{
					label: '全部',
					value: '0',
				},
				{
					label: '团长',
					value: '1',
				},
				{
					label: '团长 + 达人',
					value: '3',
				},
			],
			listType: pageConfig.tobeClaimedSearch,
			dytoShopClaimedStateList,
			goodsTypeList,
			goodsTypeSelect: [
				{
					label: '全部',
					value: '',
				},
				{
					label: '普通团长商品',
					value: '2',
				},
				{
					label: '二级团长商品',
					value: '4',
				},
			],
		};
	},
	computed: {
		zsName() {
			return zsRoleType.name;
		},
		auditStatusArr() {
			return this.$isDy(this.platformId) ? dytoBeClaimedStateList : ksMyActivityUpStateList;
		},
		dynamicsList({ auditStatusArr }) {
			let arr = [
				{
					label: '报名状态',
					key: 'audit_status',
					type: 'select',
					placeholder: '请选择',
					options: auditStatusArr,
					isShow: true,
					clearable: true,
					filterable: true,
					multiple: false,
				},
			];
			return [...arr, ...configList];
		},
		filterGoodsTypeList() {
			//过滤掉托管商品，货盘商品
			return goodsTypeList.filter(it => {
				return !['5', '1'].includes(it.value);
			});
		},
	},
	methods: {
		onClear() {
			this.formData = {
				authority_id: '',
				is_claim: '0',
				outer_shop_id: '',
				outer_activity_id: '',
			};
			this.freeOrderTime = '';
			this.$refs.shopNameSelect.clear();
			this.$emit('clear', this.formData);
		},
		changeTimed(value) {
			const [start, end] = value || [];
			this.formData.adjacent_form_time = start ? Date.parse(start) / 1000 - 8 * 3600 : '';
			this.formData.adjacent_to_time = end ? Date.parse(end) / 1000 + 16 * 3600 - 1 : '';
		},
		onSubmit: throttle(function () {
			if (this.$isKs(this.platformId) && this.formData.audit_status != 2) {
				this.$emit('clearImminent');
			}
			if (!isEqual(this.temFreeOrderTime, this.freeOrderTime)) {
				this.$emit('clearImminent');
			}
			this.$emit('onSubmit', this.formData);
		}, 1000),
		imminentSelect(toggle) {
			// 仅快手回显
			if (toggle) {
				const val = [format(new Date(), 'yyyy-MM-dd'), format(addDays(new Date(), 6), 'yyyy-MM-dd')];
				this.temFreeOrderTime = val;
				this.freeOrderTime = val;
				this.changeTimed(val);
				if (this.$isKs(this.platformId)) {
					this.formData.audit_status = '2';
				}
			} else {
				this.temFreeOrderTime = null;
				this.freeOrderTime = [];
				this.formData.adjacent_form_time = '';
				this.formData.adjacent_to_time = '';
				this.formData.audit_status = '';
				this.formData.outer_activity_id = '';
			}
			this.onSubmit();
		},
		applicationSetting(val) {
			this.formData = { is_claim: '0', ...val };
			this.$emit('onSubmit', this.formData);
		},
	},
};
</script>

<style lang="less" scoped></style>
